import React from 'react';
import { Phone, Mail, MapPin, Instagram } from 'lucide-react';
import { companyInfo } from '../mock';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gray-950 text-white border-t border-yellow-500/20">
      <div className="container mx-auto px-4 py-12">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          {/* Company Info */}
          <div>
            <div className="mb-6">
              <h3 className="text-white font-bold text-2xl tracking-tight mb-1">BALAZS</h3>
              <p className="text-yellow-400 text-base font-semibold">Dach & Abbruch Service</p>
            </div>
            <p className="text-gray-400 leading-relaxed mb-4">
              Ihr zuverlässiger Partner für professionelle Dach- und Abbrucharbeiten in Bochum und Umgebung.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-bold text-lg mb-4">Schnellzugriff</h4>
            <ul className="space-y-2">
              <li>
                <button
                  onClick={() => scrollToSection('home')}
                  className="text-gray-400 hover:text-yellow-400 transition-colors duration-200"
                >
                  Home
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('about')}
                  className="text-gray-400 hover:text-yellow-400 transition-colors duration-200"
                >
                  Über uns
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('services')}
                  className="text-gray-400 hover:text-yellow-400 transition-colors duration-200"
                >
                  Leistungen
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('references')}
                  className="text-gray-400 hover:text-yellow-400 transition-colors duration-200"
                >
                  Referenzen
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('contact')}
                  className="text-gray-400 hover:text-yellow-400 transition-colors duration-200"
                >
                  Kontakt
                </button>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-white font-bold text-lg mb-4">Unsere Leistungen</h4>
            <ul className="space-y-2 text-gray-400">
              <li>Dachdeckerarbeiten</li>
              <li>Zimmererarbeiten</li>
              <li>Klempnerarbeiten</li>
              <li>Abbrucharbeiten</li>
              <li>Fassadenarbeiten</li>
              <li>Terrassenarbeiten</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-white font-bold text-lg mb-4">Kontakt</h4>
            <ul className="space-y-3">
              <li>
                <a
                  href={`tel:${companyInfo.phone}`}
                  className="flex items-center space-x-3 text-gray-400 hover:text-yellow-400 transition-colors duration-200"
                >
                  <Phone className="w-5 h-5" />
                  <span>{companyInfo.phone}</span>
                </a>
              </li>
              <li>
                <a
                  href={`mailto:${companyInfo.email}`}
                  className="flex items-center space-x-3 text-gray-400 hover:text-yellow-400 transition-colors duration-200"
                >
                  <Mail className="w-5 h-5" />
                  <span>{companyInfo.email}</span>
                </a>
              </li>
              <li>
                <a
                  href={`https://maps.google.com/?q=${encodeURIComponent(companyInfo.address)}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-start space-x-3 text-gray-400 hover:text-yellow-400 transition-colors duration-200"
                >
                  <MapPin className="w-5 h-5 flex-shrink-0 mt-0.5" />
                  <span>{companyInfo.address}</span>
                </a>
              </li>
              <li>
                <a
                  href={companyInfo.instagramUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center space-x-3 text-gray-400 hover:text-yellow-400 transition-colors duration-200"
                >
                  <Instagram className="w-5 h-5" />
                  <span>{companyInfo.instagram}</span>
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-gray-400 text-sm">
              &copy; {currentYear} Balazs Dach & Abbruch Service UG. Alle Rechte vorbehalten.
            </p>
            <div className="flex space-x-6 text-sm">
              <a href="/impressum" className="text-gray-400 hover:text-yellow-400 transition-colors duration-200">
                Impressum
              </a>
              <a href="/datenschutz" className="text-gray-400 hover:text-yellow-400 transition-colors duration-200">
                Datenschutz
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};